<div id="header">
	<div id="nvwa-img-wrapper">

     <img id="nvwa-img"
         src= "assets/images/EN-logo-NVWA-LVVN-gecentreerd-nieuweversie.svg"
         alt="Logo Netherlands Food and Consumer Product Safety Authority">
	</div>

	<div id="header-text">
		<h1>{{ header }}</h1>
	</div>
</div>

<div>
 	<router-outlet></router-outlet>
</div>
